/*
 * MDB shim for TabPane
 * Files currently importing this symbol from "mdbreact":
 * - src/Seating/Accounts/accountDetail.jsx
 * - src/Seating/Activities/activities-edit.jsx
 * - src/Seating/Contacts/contact-edit.jsx
 * - src/Seating/Deliveries/deliveryList.jsx
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Reports/reports.jsx
 */

import MUIBox from "@mui/material/Box";

export default function TabPane({ children, tabId, activeItem, ...rest }) {
  if (activeItem && tabId && String(activeItem) !== String(tabId)) {
    return null;
  }

  return <MUIBox {...rest}>{children}</MUIBox>;
}
